import React, { useState } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  InputAdornment,
  Alert,
  Snackbar,
  Icon,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { API_URL } from "../api";
import { useNavigate } from "react-router-dom";

export default function UbahKataSandi({ navigateBack }) {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Modal konfirmasi
  const [openConfirm, setOpenConfirm] = useState(false);

  // Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleChangePassword = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("userToken");
      await axios.post(
        `${API_URL}/auth/change-password`,
        {
          currentPassword,
          newPassword,
          confirmNewPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      showSnackbar("Password berhasil diubah", "success");
      setOpenConfirm(false);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      if (navigateBack) navigateBack();
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response) {
        errorMessage =
          error.response.data.error ||
          error.response.data.message ||
          JSON.stringify(error.response.data);
      } else if (error.request) {
        errorMessage = "Tidak ada response dari server";
      } else {
        errorMessage = error.message;
      }
      showSnackbar(errorMessage, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      <header className="app-header">
        <div className="header-content">
          <button
            className="back-button"
            onClick={() => navigate("/profil-menu")}
          >
            <Icon>arrow_back</Icon>
          </button>
          <h1 className="header-title">Ubah Kata Sandi </h1>
          <div className="header-spacer"></div>
        </div>
      </header>

      <Box sx={{ px: 2 }}>
        {/* Current Password */}
        <TextField
          fullWidth
          margin="normal"
          label="Kata Sandi Sekarang"
          type={showCurrentPassword ? "text" : "password"}
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  edge="end"
                >
                  {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* New Password */}
        <TextField
          fullWidth
          margin="normal"
          label="Kata Sandi Baru"
          type={showNewPassword ? "text" : "password"}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  edge="end"
                >
                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* Confirm New Password */}
        <TextField
          fullWidth
          margin="normal"
          label="Konfirmasi Kata Sandi Baru"
          type={showConfirmPassword ? "text" : "password"}
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  edge="end"
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 2.5 }}
          onClick={() => setOpenConfirm(true)}
        >
          Ubah Kata Sandi
        </Button>
      </Box>

      {/* Modal Konfirmasi */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Konfirmasi</DialogTitle>
        <DialogContent>
          Apakah Anda yakin ingin mengubah password?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="error">
            Batal
          </Button>
          <Button
            onClick={handleChangePassword}
            color="primary"
            disabled={isLoading}
          >
            {isLoading ? "Memproses..." : "Ya"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar Notifikasi */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
